module.exports = __webpack_public_path__ + "img/jewelleryMain.4c45c8c.jpg";